<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col sm="12">
                <b-card>
                    <div slot="header">
                        <strong v-if="san.status">{{title}} - {{san.status}}</strong>
                        <strong v-else>{{title}}</strong>
                    </div>
                    <b-row>
                        <b-col sm="6">
                            <b-form-group>
                                <label for="san_date" >SAN Date</label>
                                    <b-form-input type="date" v-model="san.san_date" :disabled="lockEntry"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6">
                            <b-form-group>
                                <label for="reference_num" >Reference Num</label>
                                    <b-form-input type="text" v-model="san.reference_num" :disabled="lockEntry"></b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="6">
                            <label for="location_id">Location (Warehouse)</label>
                                <warehouseLookup v-bind:url="apiWarehouseUrl" v-on:selected="setWarehouse($event)" :lookupId="san.location_id" :disabled="lockEntry" />
                        </b-col>
                        <b-col sm="6">
                            <b-form-group>
                                <label for="reson">Reason</label>
                                    <b-form-select id="reason" v-model="san.reason"
                                        :plain="true"
                                        :options="reasonsList"
                                        value="" :disabled = "lockEntry">
                                    </b-form-select>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="12">
                            <label for="remarks">Remarks</label>
                                <textarea class="form-control" rows="5" id="remarks" v-model="san.remarks" :disabled="lockEntry"></textarea>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
        <b-row v-if = "san.location_id != '' && !noItemsFound">
            <b-col sm="12">
                <b-card>
                    <div slot ="header">
                        <strong>SAN Items</strong>
                    </div>
                    <table class='table table-striped table-bordered'>
                            <thead>
                                <th style="min-width:300px">Product Name</th>
                                <th width="250px">Product Code</th>
                                <th width="150px">SOH</th>
                                <th width="180px">Adjust Qty</th>
                                <th width="150px">Unit GMP</th>
                                <th width="180px">Total GMP</th>
                                <th width="30px"></th>
                            </thead>
                            <tbody>
                                <tr v-for="row, index in san.san_items" >
                                    <td>
                                        <productLookup v-bind:url="apiLocationProductUrl" v-on:selected="setProduct($event, index)" :lookupId="row.product_id" :q2="san.location_id" :disabled="lockEntry"/>
                                    </td>
                                    <td >{{row.product_id}}</td>
                                    <td>{{row.qty_soh}}</td>
                                    <td><input type="number" min="0" name="qty" v-model="row.qty" class="form-control" :disabled="lockEntry"/></td>
                                    <td>{{row.unit_gmp}}</td>
                                    <td>{{row.total_gmp}}</td>
                                    <td><a href="#" @click="removeRow(index)" tabindex="-1" v-if="!lockEntry"><i class='fa fa-trash' style="font-size:25px;color:red;"></i></a></td>
                                    </tr>
                                    <tr>
                                        <td colspan=7>
                                            <b-button type="submit" size="md" variant="success" @click="addRow" v-if="!lockEntry">Add Product</b-button>
                                        </td>
                                    </tr>
                                </tbody>
                        </table>
                </b-card>
            </b-col>
        </b-row>
        <b-row  v-if="san.location_id != '' && noItemsFound">
            <b-col sm="12">
                <div align="center">
                    <strong style="color:red">No Products Found in the Selected Warehouse! Please Select a Different Warehouse</strong>
                </div>
            </b-col>
        </b-row>
        <b-row v-if = "san.location_id != '' && !noItemsFound ">
                <b-col sm="12">
                    <b-row style="padding: 0px 0px 20px 18px;">
                            <b-button type="submit" size="lg" variant="primary" @click="confirmSave" v-if="!lockEntry">Save SAN</b-button>
                                 &nbsp;&nbsp;
                            <b-button type="submit" size="lg" variant="danger" @click="confirmCancel" v-if="!lockEntry">Cancel</b-button>
                            <b-button type="submit" size="lg" variant="primary" @click="confirmApprove" v-if="btnVisible && san.status == 'NEW' ">Approve</b-button>
                            &nbsp;
                            <b-button type="button" size="lg" variant="danger" @click="confirmReject"  v-if="btnVisible && san.status == 'NEW'">Reject</b-button>
                            &nbsp;
                            <b-button type="submit" size="lg" variant="success" @click="print" v-if="lockEntry">Print</b-button>&nbsp;&nbsp;
                            <b-button type="submit" size="lg" variant="danger" @click="back" v-if="lockEntry">Back</b-button>
                    </b-row>
                </b-col>
        </b-row>
        <b-modal v-model="modalShow" @ok="save" title="Confirmation"  centered header-bg-variant="success" no-close-on-backdrop>
                <p style="color:darkblue">Confirmed Save SAN?</p>
        </b-modal>
        <b-modal v-model="approveModalShow" @ok="approve" title="Confirmation"  centered header-bg-variant="success" no-close-on-backdrop>
            <p style="color:darkblue">Confirmed Approve SAN?</p>
        </b-modal>
        <b-modal v-model="modalCancelShow" @ok="cancel" title="Confirmation"  centered header-bg-variant="success" no-close-on-backdrop>
                <p style="color:darkblue">Confirmed Cancel?</p>
        </b-modal>
        <b-modal ref="myModalRef" hide-header-close hide-footer title="Stock Adjustment Note" centered header-bg-variant="success" no-close-on-backdrop no-close-on-esc>
            <div class="d-block text-center">
                <p>Stock Adjustment Note<strong style="color:green"> {{sanDocNo}}</strong> is {{confirmTxt}}.<br/><br/></p>
            </div>
                <b-btn class="float-right" variant="outline-danger" @click="hideModal">Ok</b-btn>
        </b-modal>
        <b-modal ref="myErrorModalRef" hide-header-close hide-footer title="Invalid Entries" centered header-bg-variant="danger" no-close-on-backdrop no-close-on-esc>
            <div class="d-block text-center">
                <p style="color:red">{{errorMessage}}</p>
            </div>
                <b-btn class="float-right" variant="danger" @click="hideErrorModal">OK</b-btn>
        </b-modal>
        <b-modal ref="msgBox" hide-header-close hide-footer :title="mbTitle" centered header-bg-variant="primary" no-close-on-backdrop no-close-on-esc>
            <div class="d-block text-center">
                <p style="color:green">{{mbMsg}}</p>
            </div>
                <b-btn class="float-right" variant="danger" @click="$refs.msgBox.hide()">OK</b-btn>
        </b-modal>
        <b-modal id="modalPrevent"
            ref="rejectModal"
            title="Reject SAN?"
            centered
            @ok="reject"
        >
        <form @submit.stop.prevent="handleSubmit">
            <b-form-input type="text" placeholder="Enter the reason" v-model="san.san_reject_remarks"></b-form-input>
        </form>
    </b-modal>
    </div>
</template>
<script>
import axios from 'axios'
import warehouseLookup from '@/components/Autocomplete.vue'
import countryLookup from '@/components/Autocomplete.vue'
import productLookup from '@/components/Autocomplete.vue'
import {authHeader, apiWarehouseLookup, apiLocationProductUrl,apiCountryLookup, apiSanSave,apiSanGet,apiSanClose,apiSanApprove} from '@/functions/common.vue'
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

pdfMake.vfs = pdfFonts.pdfMake.vfs;
pdfMake.fonts = {
    "ukai": {
        normal: 'ukai.ttf',
        bold: 'ukai.ttf',
        italics: 'ukai.ttf',
        bolditalics: 'ukai.ttf'
    },
    "Garuda": {
        normal: 'Garuda.ttf',
        bold: 'Garuda.ttf',
        italics: 'Garuda.ttf',
        bolditalics: 'Garuda.ttf'
    },
    "Hanumanb": {
        normal: 'Hanumanb.ttf',
        bold: 'Hanumanb.ttf',
        italics: 'Hanumanb.ttf',
        bolditalics: 'Hanumanb.ttf'
    },
};

export default
{
    components:{warehouseLookup,productLookup,countryLookup},
    computed:
    {
        reasonsList: function() {
            var list = []

            list.push('')
            list.push('CONVERSION')
            list.push('STOCK COUNT VARIANCE')
            list.push('SHIPMENT DISCREPANCY')
            list.push('GRB / WRITE-OFF ITEM')
            list.push('RECEIVING ERROR BY STAFF')
            list.push('OTHERS')

            return list
        }
    },
    data: () => {
        return {
            isWh: false,
            isWhHoo: false,
            isAcc: false,
            isAccFn: false,
            mbTitle: "",
            mbMsg: "",
            country_name:'',
            backBtnVisible : false,
            title:'New SAN',
            apiWarehouseUrl:apiWarehouseLookup,
            apiLocationProductUrl:apiLocationProductUrl,
            modalShow:false,
            approveModalShow:false,
            modalCancelShow:false,
            noItemsFound : true,
            btnVisible : false,
            confirmTxt:'',
            lockEntry:false,
            sanDocNo:'12345',
            errorMessage:'',
            font:'ukai',
            san :
            {
                san_date:'',
                location_id:'',
                status:'',
                reference_num:'',
                reason:'',
                san_reject_remarks:'',
                remarks:'',
                san_items :
                [
                  {product_name:'', product_id:'', qty_soh:'', qty:'',unit_gmp:'',total_gmp:''}
                ]
            }
        }
    },
    created()
    {
        var app_role

        app_role = JSON.parse(localStorage.getItem("app_role"))
        this.isWh = app_role.includes("WH")
        this.isWhHoo = app_role.includes("WH_HOO")
        this.isAcc = app_role.includes("AC")
        this.isAccFn = app_role.includes("AC_FN")
        //alert(app_role)

        this.san_ref = this.$route.params.sanNum
        if(this.san_ref == '_new')
        {
            let curDate = new Date()
            curDate = curDate.toISOString().substr(0,10)
            this.san.san_date = curDate
            this.noItemsFound = true
        }
        else
        {
            this.lockEntry = true
            console.log(this.btnVisible)
            this.fetch(this.san_ref)
            this.title = "Stock Adjustment Note" + this.$route.params.sanNum
            this.noItemsFound = false
        }
    },
    methods:
    {
        print()
            {
                    var san_num = this.san.san_num
                    var row = []
                    var date = new Date(this.san.san_date)
                    var sanDate = "" + (date.getDate() > 9 ? '' : '0') + date.getDate() + '/' + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear()
                    var sanItems = []
                    var approver = '-'
                    var approvedDate = '-'
                    var rejection_remarks = '-'
                    if(this.san.rejection_reason != null)
                    {
                        rejection_remarks = this.san.rejection_reason
                    }
                    console.log(this.san)
                    if(this.san.approver_user_shortname != null)
                    {
                        approver =this.san.approver_user_shortname
                    }
                    if(this.san.approved_date != null)
                    {
                        var d = new Date(this.san.approved_date)
                        approvedDate = "" + (d.getDate() > 9 ? '' : '0') + d.getDate() + '/' + ((d.getMonth() + 1) > 9 ? '' : '0') + (d.getMonth() + 1) + '/' + d.getFullYear()
                    }
                    var approvedText = "Approved By"
                    if(this.san.status == 'REJECTED')
                    {
                        approvedText = 'Rejected By'
                    }
                    row = [
                        {
                            text: 'S/No',
                            style: 'itemsHeader'
                        },
                        {
                            text: 'Product Code',
                            style: ['itemsHeader'],
                            alignment: 'left'
                        },
                        {
                            text: 'Description',
                            style: ['itemsHeader'],
                            alignment: 'left'
                        },
                        {
                            text: 'SOH',
                            style: ['itemsHeader'],
                            alignment: 'left'
                        },
                        {
                            text: 'Unit GMP',
                            style: ['itemsHeader'],
                            alignment: 'left'
                        },
                        {
                            text: 'Total GMP',
                            style: ['itemsHeader'],
                            alignment: 'left'
                        },
                        {
                            text: 'Qty',
                            style: ['itemsHeader'],
                            alignment: 'right'
                        }
                    ]
                    sanItems.push(row)
                    var items = this.san.san_items
                    for (let key in items) {
                        var data = items[key]
                        var soh = (data.qty_soh * 1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        var qty = (data.qty* 1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        var unit_gmp = (data.unit_gmp * 1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        var total_gmp = (data.total_gmp * 1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        if (data.product_name == null)
                        {
                            data.product_name = ""
                        }
                        row = [
                            {
                                text: (key * 1) + 1,
                                style: 'itemText'
                            },
                            {
                                text: data.product_id,
                                style: 'itemText'
                            },
                            {
                                text: data.product_name,
                                style: 'itemText'
                            },
                            {
                                text: soh,
                                style: 'itemText'
                            },
                            {
                                text: unit_gmp,
                                style: 'itemText'
                            },
                            {
                                text: total_gmp,
                                style: 'itemText'
                            },
                            {
                                text: qty,
                                style: 'itemNumber'
                            },
                        ]
                        sanItems.push(row)
                    }

                    var ddHeader = {
                        columns: [
                            [{
                                    text: 'ELKEN '+ this.country_name + ' STOCK ADJUSTMENT NOTE',
                                    style: 'invoiceTitle',
                                    width: '*'
                                },
                                {
                                    stack: [{
                                            columns: [
                                                {
                                                    text: 'SAN #',
                                                    style: 'invoiceSubTitle',
                                                    width: 95

                                                },
                                                {
                                                    text: san_num,
                                                    style: 'invoiceSubValue',
                                                    width: 100
                                                },

                                            ]
                                        },
                                        {
                                            text:' '
                                        },
                                        {
                                            columns: [

                                                {
                                                    text: 'SAN Date',
                                                    style: 'invoiceSubTitle',
                                                    width: 95

                                                },
                                                {
                                                    text: sanDate,
                                                    style: 'invoiceSubValue',
                                                    width: 100

                                                },

                                            ]

                                        },
                                        {
                                            text:' ',
                                        },
                                        {
                                            columns: [
                                                {
                                                    text: 'Status',
                                                    style: 'invoiceSubTitle',
                                                    width: 95

                                                },
                                                {
                                                    text: this.san.status,
                                                    style: 'invoiceSubValue',
                                                },

                                            ]
                                        },
                                        {
                                            text:' '
                                        },
                                        {
                                            columns: [
                                                {
                                                    text: 'Stock Location',
                                                    style: 'invoiceSubTitle',
                                                    width: 95

                                                },
                                                {
                                                    text: this.san.location_id,
                                                    style: 'invoiceSubValue',
                                                },

                                            ]
                                        },
                                        {
                                            text:' ',
                                        },
                                        {
                                            columns: [
                                                {
                                                    text: 'Reason',
                                                    style: 'invoiceSubTitle',
                                                    width: 95

                                                },
                                                {
                                                    text: this.san.reason,
                                                    style: 'invoiceSubValue',
                                                },
                                            ]
                                        },
                                        {
                                            text:' ',
                                        },
                                        {
                                            columns: [
                                                {
                                                    text: 'Reference #',
                                                    style: 'invoiceSubTitle',
                                                    width: 95

                                                },
                                                {
                                                    text: this.san.reference_num,
                                                    style: 'invoiceSubValue',
                                                },
                                            ]
                                        },
                                    ]
                                }
                            ],
                        ],
                    }

                    var dd = {
                        header: function (pageNumber, pageCount) {
                            return {
                                margin: [0, 10, 0, 0],
                                columns: [{
                                        text: '',
                                        style: 'documentHeaderLeft'
                                    },
                                    {
                                        text: san_num,
                                        style: 'documentHeaderCenter'
                                    },
                                    {
                                        text: '',
                                        style: 'documentHeaderRight'
                                    }
                                ]
                            }
                        },
                        footer: function (pageNumber, pageCount) {
                            return {
                                margin: [0, 0, 0, 50],
                                columns: [{
                                        text: '',
                                        style: 'documentFooterLeft'
                                    },
                                    {
                                        text: 'Page ' + pageNumber + " of " + pageCount,
                                        style: 'documentFooterCenter'
                                    },
                                    {
                                        text: '',
                                        style: 'documentFooterRight'
                                    }
                                ]
                            };
                        },
                        content: [
                            ddHeader,
                            // Line breaks
                            '\n\n',
                            {
                                layout: 'lightHorizontalLines',
                                table: {

                                    headerRows: 1,
                                    widths: [25, 68, '*', 55, 55,55,45],
                                    body: sanItems

                                }, // table
                            },
                            {
                                text: 'Remarks',
                                style: 'notesTitle'
                            },
                            {
                                text: this.san.remarks,
                                style: 'notesText'
                            },
                            {
                                text: 'Rejection Remarks',
                                style: 'notesTitle'
                            },
                            {
                                text: rejection_remarks,
                                style: 'notesText'
                            },
	    {
	        columns: [
	            {
	                stack: [
                        {
	                        text: 'Issued By',
	                        style:'signaturePlaceholder'
	                    },
	                    {
	                        text: '____________________________',
	                        style:'signaturePlaceholder'
	                    },
	                    {
	                        text: 'Name  :'+this.san.author_user_shortname,
	                        style:'signatureName'

	                    },
	                    {
	                        text: 'Date  :'+ sanDate,
	                        style:'signatureJobTitle'

	                    }
	                    ],
	               width: 160
                },
                {
	                stack: [
                        {
	                        text: ' ',
	                        style:'signaturePlaceholder'
	                    },
	                    {
	                        text: ' ',
	                        style:'signaturePlaceholder'
	                    },
	                    {
	                        text: '                 ',
	                        style:'signatureName'

	                    },
	                    {
	                        text: ' ',
	                        style:'signatureJobTitle'

	                    }
	                    ],
	               width: 160
	            },
	            {
	                stack: [
                        {
	                        text: approvedText,
	                        style:'signaturePlaceholder'
	                    },
	                    {
	                        text: '______________________________',
	                        style:'signaturePlaceholder'
	                    },
	                    {
	                        text: 'Name : '+ approver,
	                        style:'signatureName'

	                    },
	                    {
	                        text: 'Date  : '+ approvedDate,
	                        style:'signatureJobTitle'

	                    }
	                    ],
	               width: 160
	            },
	        ]
	    },
                        ],
                        styles: {
                            // Document Header
                            documentHeaderLeft: {
                                fontSize: 10,
                                margin: [5, 5, 5, 5],
                                alignment: 'left'
                            },
                            documentHeaderCenter: {
                                fontSize: 10,
                                margin: [5, 5, 5, 5],
                                alignment: 'center'
                            },
                            documentHeaderRight: {
                                fontSize: 10,
                                margin: [5, 5, 5, 5],
                                alignment: 'right'
                            },
                            // Document Footer
                            documentFooterLeft: {
                                fontSize: 10,
                                margin: [5, 5, 5, 5],
                                alignment: 'left'
                            },
                            documentFooterCenter: {
                                fontSize: 10,
                                margin: [5, 5, 5, 5],
                                alignment: 'center'
                            },
                            documentFooterRight: {
                                fontSize: 10,
                                margin: [5, 5, 5, 5],
                                alignment: 'right'
                            },
                            // Invoice Title
                            invoiceTitle: {
                                fontSize: 22,
                                bold: true,
                                alignment: 'left',
                                margin: [0, 0, 0, 15]
                            },
                            // Invoice Details
                            invoiceSubTitle: {
                                fontSize: 10,
                                alignment: 'left'
                            },
                            invoiceSubValue: {
                                fontSize: 10,
                                alignment: 'left'
                            },
                            // Billing Headers
                            invoiceBillingTitle: {
                                fontSize: 14,
                                bold: true,
                                alignment: 'left',
                                margin: [0, 20, 0, 5],
                            },
                            // Billing Details
                            invoiceBillingDetails: {
                                alignment: 'left'

                            },
                            invoiceBillingAddressTitle: {
                                margin: [0, 7, 0, 3],
                                bold: true
                            },
                            invoiceBillingAddress: {

                            },
                            // Items Header
                            itemsHeader: {

                                fontSize: 10,
                                margin: [0, 5, 0, 5],
                                bold: true
                            },
                            // Item Title
                            itemTitle: {
                                bold: true,
                            },
                            itemSubTitle: {
                                //italics: true,
                                fontSize: 10
                            },
                            itemText: {
                                fontSize: 10,
                                margin: [0, 5, 0, 5],
                                alignment: 'left',
                            },
                            itemNumber: {
                                fontSize: 10,
                                margin: [0, 5, 0, 5],
                                alignment: 'right',
                            },
                            itemTotal: {
                                fontSize: 10,
                                margin: [0, 5, 0, 5],
                                bold: true,
                                alignment: 'right',
                            },

                            // Items Footer (Subtotal, Total, Tax, etc)
                            itemsFooterSubTitle: {
                                margin: [0, 5, 0, 5],
                                bold: true,
                                alignment: 'right',
                            },
                            itemsFooterSubValue: {
                                margin: [0, 5, 0, 5],
                                bold: true,
                                alignment: 'center',
                            },
                            itemsFooterTotalTitle: {
                                fontSize: 11,
                                margin: [0, 5, 0, 5],
                                bold: true,
                                alignment: 'right',
                            },
                            itemsFooterTotalValue: {
                                fontSize: 11,
                                margin: [0, 5, 0, 5],
                                bold: true,
                                alignment: 'center',
                            },
                            signaturePlaceholder: {
                                fontSize: 10,
                                margin: [0, 70, 0, 0],
                            },
                            signatureName: {
                                fontSize: 10,
                                margin: [0, 10, 0, 0],
                                bold: true,
                                alignment: 'left',
                            },
                            signatureJobTitle: {
                                fontSize: 10,
                                margin: [0, 20, 0, 0],
                                bold: true,
                                alignment: 'left',
                            },
                            notesTitle: {
                                fontSize: 10,
                                bold: true,
                                margin: [0, 30, 0, 3],
                            },
                            notesText: {
                                fontSize: 10
                            },
                            center: {
                                alignment: 'center',
                            },
                        },
                        defaultStyle: {
                            columnGap: 20,
                            font:this.font
                        }
                    }
                    pdfMake.createPdf(dd).open();
                },
        approve()
        {
            //this.san.status = "APPROVED"
            if (this.isWhHoo)
            {
                axios.post(apiSanApprove, {san_num: this.san.san_num, approve: 1,reason:''},authHeader())
                    .then (res => {
                        this.san.status = "APPROVED"
                        this.mbTitle = "Approve"
                        this.mbMsg = "SAN " + this.san.san_num + " has been Aproved."
                        this.$refs.msgBox.show()
                        this.fetch(this.san_ref)
                    })
                    .catch(error => alert(error))
            }
            else if(this.isAccFn)
            {
                axios.post(apiSanApprove, {san_num: this.san.san_num, approve: 1},authHeader())
                    .then (res => {
                        this.san.status = "APPROVED"
                        this.mbTitle = "Approve"
                        this.mbMsg = "SAN " + this.san.san_num + " has been Aproved."
                        this.$refs.msgBox.show()
                        this.fetch(this.san_ref)
                    })
                    .catch(error => alert(error))
            }
        },
        confirmApprove()
        {
            this.approveModalShow = true
        },
        confirmReject()
        {
            this.$refs.rejectModal.show()
        },
        reject()
        {
            this.$refs.rejectModal.hide()
            if (this.san.san_reject_remarks != '' && this.san.san_reject_remarks != null)
            {
                axios.post(apiSanApprove, {san_num: this.san.san_num, approve: 0,reason:this.san.san_reject_remarks},authHeader())
                .then (res => {
                    if(res.data.code == 1)
                    {
                        this.san.status = "REJECTED"
                        this.mbTitle = "Reject"
                        this.mbMsg = "SAN " + this.san.san_num + " has been Rejected."
                        this.$refs.msgBox.show()
                        this.fetch(this.san_ref)
                    }

                })
                .catch(error => alert(error))
            }
            else
            {
                this.mbTitle = "Manual Close cancelled"
                this.mbMsg = "Reason has to be provided"
                this.$refs.msgBox.show()
            }
        },
        fetch(sanNum)
        {
            axios.post(apiSanGet, {san_num:sanNum}, authHeader())
            .then (res =>
            {
              var data
              data = res.data.data

              this.san = data
              if(this.san.country_id != null)
                {
                    if(this.san.country_id == 'TH')
                    {
                        this.font = 'Garuda'
                    }
                    else if(this.san.country_id == 'KH')
                    {
                        this.font = 'Hanumanb'
                    }
                    axios.get(apiCountryLookup, {params: {q: this.san.country_id}})
                        .then(response =>
                        {

                            if (response.data != null)
                            {
                                this.list = response.data.data.list
                                this.item = this.list[0]
                                this.country_name = this.item.country_name
                                this.country_name = this.country_name.toUpperCase()
                            }
                        })
                }
              this.title = "Stock Adjustment Note " + sanNum
              if(this.isAccFn)
              {
                  this.btnVisible = true
              }
              else if (this.isWhHoo)
              {
                if(this.lockEntry && this.san.reason == "CONVERSION")
                  {
                      this.btnVisible = true
                  }
                  else
                  {
                    this.backBtnVisible = true
                  }
              }
              else if(this.isWh)
              {
                this.backBtnVisible = true
              }
              else if (this.isAcc)
              {
                  this.backBtnVisible = true
              }
            })
            .catch(error => alert(error)
          )
        },
        setWarehouse(obj)
        {
            if (!this.lockEntry)
            {
                var id

                if (obj !== null)
                {
                    if (obj.id != this.san.location_id)
                    {
                        id = obj.id
                        this.san.san_items = []
                        this.san.location_id = id
                        if (this.san.location_id != '')
                        {
                           axios.get(this.apiLocationProductUrl,{params: {q:'', q2: id}})
                                .then (res => {
                                    var list
                                    list = res.data.data.list
                                    console.log(list.length)
                                    this.noItemsFound = (list.length == 0)
                                })
                                .catch(error => alert(error))
                        }
                    }
                }
                else
                {
                    id = ""
                    this.noItemsFound = true
                }

            }
        },
        addRow ()
        {
            this.san.san_items.push({product_id:'', product_name:'', qty_soh:'', qty:'',unit_gmp:'',total_gmp:''});
        },
        removeRow (index)
        {
            this.san.san_items.splice(index, 1);
        },
        setProduct(obj, index)
        {
            if (!this.lockEntry)
            {
                var name, id, qty_soh, qty, unit_gmp

                if(obj !== null)
                {
                    name = obj.name
                    id = obj.id
                    qty_soh = obj.qty_soh
                    unit_gmp = obj.unit_gmp
                }
                else
                {
                    name = ""
                    id = ""
                    qty_soh = ""
                    unit_gmp = ""
                }

                this.san.san_items[index].product_id = id
                this.san.san_items[index].product_name = name
                this.san.san_items[index].qty_soh = qty_soh
                this.san.san_items[index].unit_gmp = unit_gmp
                this.san.san_items[index].total_gmp = (1 * qty_soh) * (1 * unit_gmp)

            }
        },
        confirmSave()
        {
            this.confirmTxt = " created"
            this.modalShow = true
        },
        save()
        {

            var san_date = this.san.san_date
            var today = new Date();
            var dd = today.getDate();
            var mm = today.getMonth()+1; //January is 0!
            var yyyy = today.getFullYear();

            if(dd<10)
            {
                dd='0'+dd;
            }
            if(mm<10)
            {
                mm='0'+mm;
            }
            var today = yyyy+'-'+mm+'-'+dd;
            if(san_date >= today)
            {
                axios.post(apiSanSave, this.san, authHeader())
                        .then (res => {
                        var r = res.data
                        if (r.code == 1)
                        {
                            this.sanDocNo = r.data.san_num
                            this.$refs.myModalRef.show()
                        }
                        else
                        {
                            this.errorMessage = r.msg
                            this.$refs.myErrorModalRef.show()
                        }
                        })
                .catch(error => alert(error))
            }
            else
            {
                this.errorMessage = "Post Dated date entry not allowed for SAN date"
                this.$refs.myErrorModalRef.show()
            }


        },
        confirmCancel()
        {
            this.modalCancelShow = true
        },
        cancel()
        {
            this.$router.push({ name: 'Stock Adjustment Notes (SANS)'})
        },
        hideModal ()
        {
            this.$refs.myModalRef.hide()
            this.$router.push({ name: 'Stock Adjustment Notes (SANS)'})
        },
        hideErrorModal()
        {
            this.$refs.myErrorModalRef.hide()
        },
        back()
        {
            this.$router.push({ name: 'Stock Adjustment Notes (SANS)'})
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/views/san/san.vue